// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo-wrapper[data-v-019f9ebe]{align-items:center;display:flex;flex-direction:column}.logo-height[data-v-019f9ebe]{height:3rem}.teams-panel[data-v-019f9ebe]{padding:2rem 1rem}.teams-login[data-v-019f9ebe]{align-items:center;display:flex;flex-direction:row;gap:.75rem;justify-content:center;margin-top:2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
